import { useMobile } from 'shared/domains/common-ui';
import { autosave } from './autosave';
import { CustomSuggestionThreadView } from '../../../views/CustomSuggestionThreadView';
import { useGetToken } from '../useGetToken';
export const useConfig = (options) => {
    const isMobile = useMobile();
    const getEditorToken = useGetToken();
    const { documentId, documentType, plugins, toolbarItems, balloonToolbarItems, refs, currentUser, featureAvailability, } = options;
    const { editorContainerRef, viewerContainerRef, viewerEditorElementRef, viewerSidebarContainerRef, sidebarContainerRef, } = refs;
    const licenseKey = process.env.PLEDITOR_LICENSE_KEY;
    const cloudServicesConfig = {
        channelId: documentId,
        tokenUrl: getEditorToken,
        webSocketUrl: 'wss://105599.cke-cs.com/ws',
    };
    const featureAvailabilityFallback = Object.assign({ suggestions: false }, featureAvailability);
    const baseConfig = {
        licenseKey,
        documentId,
        currentUser,
        featureAvailability: featureAvailabilityFallback,
        language: 'en',
        plugins: [...plugins],
        toolbar: {
            shouldNotGroupWhenFull: !isMobile,
            items: toolbarItems,
        },
        balloonToolbar: {
            items: balloonToolbarItems,
        },
        autosave: {
            save: autosave,
            waitingTime: 3000,
        },
        comments: {
            editorConfig: {},
        },
        cloudServices: {
            tokenUrl: cloudServicesConfig.tokenUrl,
            webSocketUrl: cloudServicesConfig.webSocketUrl,
        },
        collaboration: {
            channelId: cloudServicesConfig.channelId,
        },
        table: {
            defaultHeadings: { rows: 1 },
        },
        sidebar: {
            preventScrollOutOfView: true,
            container: sidebarContainerRef,
        },
    };
    const freeTextConfig = {
        revisionHistory: {
            resumeUnsavedRevision: false,
            editorContainer: editorContainerRef,
            viewerContainer: viewerContainerRef,
            viewerEditorElement: viewerEditorElementRef,
            viewerSidebarContainer: viewerSidebarContainerRef,
        },
        indentBlock: {
            classes: ['ck-custom-block-indent-1', 'ck-custom-block-indent-2', 'ck-custom-block-indent-3'],
        },
        trackChanges: {
            disableComments: true,
            mergeNestedSuggestions: true,
            trackFormatChanges: 'default',
            SuggestionThreadView: CustomSuggestionThreadView,
        },
    };
    if (documentType === 'composed') {
        return baseConfig;
    }
    return Object.assign(Object.assign({}, baseConfig), freeTextConfig);
};
